import { useCallback, useMemo } from "react"

import { useNavigate } from "react-router-dom"
import { useQueryClient } from "@tanstack/react-query"

import useUser from "../useUser"
import { getToken } from "../useAuthStorage"
import { useAppDispatch } from "../useAppDispatch"

import { logout } from "@/slices/user"

function getTenantPrefix(): string {
  if (typeof window === "undefined") return ""
  const host = window.location.hostname.toLowerCase()
  const firstPath = window.location.pathname.replace(/^\/+/, "").split("/")[0]?.toLowerCase() || ""
  if (host.includes("claricel") || firstPath === "claricel") return "claricel"
  if (host.includes("nxum") || firstPath === "nxum") return "nxum"
  if (host.includes("infynit") || firstPath === "infynit") return "infynit"
  if (host.includes("pandamovil") || firstPath === "pandamovil" || firstPath === "panda") return "pandamovil"
  if (host.includes("celink") || firstPath === "celink") return "celink"
  return ""
}

function getBasePath(pathname: string): string {
  const knownRootRoutes = new Set([
    "",
    "login",
    "inicio",
    "usuarios",
    "clientes",
    "portabilidad",
    "consulta-uf",
    "batch",
    "ventas",
    "menu",
    "ofertas",
    "datos-empresa",
    "msisdn",
    "facturacion",
    "ecommerce",
    "beneficios",
    "ecommerce-products",
    "esim-profiles",
    "empresas",
    "promociones-altan",
    "promociones",
  ])
  const first = pathname.replace(/^\/+/, "").split("/")[0]?.toLowerCase() || ""
  if (!first || knownRootRoutes.has(first)) return ""
  return `/${first}`
}

const useLoggedIn = () => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const dispatch = useAppDispatch()
  const { user, loadingUserInfo } = useUser()
  const closeSession = useCallback(async () => {
    dispatch(logout())
    const prefix = getTenantPrefix()
    if (prefix) {
      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith(`${prefix}:`)) localStorage.removeItem(key)
      })
    } else {
      ;["admin", "pasarela_recarga", "inicio", "activeCompanyId", "activeCompanyName"].forEach((k) => localStorage.removeItem(k))
    }
    navigate(`${getBasePath(window.location.pathname)}/login`.replace(/\/{2,}/g, "/"))
    queryClient.removeQueries()
    window.location.reload()
  }, [dispatch, navigate, queryClient])

  const isLoggedIn = useMemo(() => {
    return !!getToken()
  }, [user])

  return { isLoggedIn, closeSession, user, loadingUserInfo }
}

export { useLoggedIn }
